import {
  Datagrid,
  FunctionField,
  List,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  FormDataConsumer,
} from "react-admin";
import {
  CreateInDialogButton,
  EditInDialogButton,
} from "@react-admin/ra-form-layout";
import { useRecordContext } from "react-admin";
import PropTypes from "prop-types";

const matchOptions = [
  { id: 0, name: "Make" },
  { id: 1, name: "Model" },
  { id: 2, name: "Model Series" },
  { id: 3, name: "Engine size" },
  { id: 4, name: "Fuel type" },
  { id: 5, name: "Year Registered" },
  { id: 6, name: "Month Registered" },
  { id: 7, name: "Body type" },
  { id: 8, name: "Transmission" },
  { id: 9, name: "Aspiration" },
  { id: 10, name: "Mileage" },
  { id: 11, name: "Engine code" },
  { id: 12, name: "No. Doors" },
  { id: 13, name: "Curb Weight" },
  { id: 14, name: "Engine condition" },
  { id: 15, name: "High Price" },
  { id: 16, name: "Gearbox condition" },
  { id: 17, name: "MOT Failure" },
  { id: 18, name: "Crash Damaged" },
  { id: 19, name: "Insurance write off condition" },
  { id: 20, name: "Repaired" },
  { id: 21, name: "Previous Keepers" },
  { id: 22, name: "CAP Average" },
  { id: 23, name: "CAP Clean" },
  { id: 24, name: "CAP Salvage" },
  { id: 25, name: "CAP Retail" },
  { id: 26, name: "ML Prediction" },
  { id: 27, name: "ML Uncertainty" },
  { id: 28, name: "ML Prediction / Cap Value" },
];

const criteriaOptions = [
  { id: 0, name: "Equal to" },
  { id: 1, name: "Not Equal to" },
  { id: 2, name: "Greater than or equal to" },
  { id: 3, name: "Less than" },
  { id: 4, name: "Contains" },
  { id: 5, name: "Does not contain" },
];

// Match types that use a fixed dropdown for matchValue rather than free text
const selectTypes = [14, 16, 17, 18, 19, 20];

const matchValueChoices = {
  14: [
    { id: "1", name: "No Faults" },
    { id: "2", name: "Faulty But Runs" },
    { id: "3", name: "Doesn't Run" },
  ],
  16: [
    { id: "1", name: "No Faults" },
    { id: "2", name: "Faulty But Runs" },
    { id: "3", name: "Doesn't Run" },
  ],
  17: [
    { id: "0", name: "No" },
    { id: "1", name: "Yes" },
  ],
  18: [
    { id: "1", name: "No" },
    { id: "2", name: "Yes" },
    { id: "3", name: "Yes (Airbag deployed)" },
  ],
  19: [
    { id: "1", name: "No" },
    { id: "2", name: "CAT C" },
    { id: "3", name: "CAT D" },
    { id: "4", name: "CAT S" },
    { id: "5", name: "CAT N" },
  ],
  20: [
    { id: "0", name: "No" },
    { id: "1", name: "Yes" },
  ],
};

const DatagridActionsColumn = ({ children }) => <>{children}</>;
DatagridActionsColumn.propTypes = { children: PropTypes.any };

const ConditionsPanel = () => {
  const record = useRecordContext();

  const fakeProps = { resource: "ml-pricing-rule-conditions" };

  const ConditionForm = (props) => (
    <SimpleForm {...props}>
      <SelectInput
        source="matchType"
        choices={matchOptions}
        fullWidth
        label="Match Type"
      />
      <SelectInput
        source="matchCriteria"
        choices={criteriaOptions}
        fullWidth
        label="Criteria"
      />
      <FormDataConsumer>
        {({ formData }) =>
          formData.matchType !== undefined &&
          selectTypes.includes(formData.matchType) ? (
            <SelectInput
              source="matchValue"
              choices={matchValueChoices[formData.matchType]}
              fullWidth
              label="Value"
            />
          ) : (
            <TextInput source="matchValue" fullWidth label="Value" />
          )
        }
      </FormDataConsumer>
    </SimpleForm>
  );

  const createButton = (
    <CreateInDialogButton
      inline
      fullWidth
      title="Add Condition"
      record={{ rule: record.id }}
    >
      <ConditionForm />
    </CreateInDialogButton>
  );

  const editButton = (
    <EditInDialogButton title="Edit Condition">
      <ConditionForm />
    </EditInDialogButton>
  );

  return (
    <>
      <h3>Conditions</h3>
      <List
        style={{ width: "100%" }}
        {...fakeProps}
        actions={createButton}
        filter={{ "rule.id": record.id }}
        empty={createButton}
      >
        <Datagrid bulkActionButtons={false}>
          <FunctionField
            label="Match Type"
            source="matchType"
            render={(r) =>
              matchOptions.find((o) => o.id === r.matchType)?.name ??
              r.matchType
            }
          />
          <FunctionField
            label="Criteria"
            source="matchCriteria"
            render={(r) =>
              criteriaOptions.find((o) => o.id === r.matchCriteria)?.name ??
              r.matchCriteria
            }
          />
          <TextField source="matchValue" label="Value" />
          <DatagridActionsColumn label="Actions">
            {editButton}
          </DatagridActionsColumn>
        </Datagrid>
      </List>
    </>
  );
};

export default ConditionsPanel;
